import React from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";

// page
import Home from './pages/home'
import Policy from './pages/policy'

export default class AppRouter extends React.Component {
  render(){
      return (    
          <Router>
            <Switch> 
                <Route path="/policy" component={Policy} />
                <Route path="/" component={Home} />
                <Redirect to="/" />
            </Switch>
          </Router>    
      );
  }
}
